module.exports = __webpack_public_path__ + "static/media/slice.24e262e4.svg";